import { render } from "./MenuGroup.vue?vue&type=template&id=790ce50d"
import script from "./MenuGroup.vue?vue&type=script&lang=js"
export * from "./MenuGroup.vue?vue&type=script&lang=js"

import exportComponent from "/home/malezha/zfort/digitalfax/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MenuGroup.vue"]])

export default __exports__